module.exports = __webpack_public_path__ + "img/journal.7010f064.svg";